import React from 'react';
import './Loader.css'

export default function Loader() {
    return (
        <div className="loader-root">
            <div className="backdrop-root"></div>
            <div className="loader"></div> 
        </div >

    )
}